export default __webpack_public_path__ + "static/economics-icon-c0e1dc686435a77ba83d035bb5885b38.svg";